const mutations = {
  setDefaultData(state, payload) {
    state.qna_config = payload;
  },
};

export default mutations;
